import React from "react";
import type { DocumentInsightAsset } from "./types";
import { PromptInsights } from "./PromptInsights";
import { StepContent, StepRow, StepSpacer } from "./Autopilot.styled";

interface PromptInsightsStepProps {
  documentInsight?: DocumentInsightAsset;
  onComplete: () => void;
  skipAnimations?: boolean;
  stepRef?: (el: HTMLDivElement | null) => void;
}

export const PromptInsightsStep: React.FC<PromptInsightsStepProps> = ({
  documentInsight,
  onComplete,
  skipAnimations,
  stepRef,
}) => {
  return (
    <StepRow ref={stepRef}>
      <StepContent>
        <PromptInsights
          documentInsight={documentInsight}
          onComplete={onComplete}
          skipAnimations={skipAnimations}
        />
        <StepSpacer />
      </StepContent>
    </StepRow>
  );
};
